import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/Assignment'; // Registered
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate'; // REJECTED
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'; // APPROVED
import NotInterestedIcon from '@material-ui/icons/NotInterested'; // REVOKED
import WarningIcon from '@material-ui/icons/Warning'; // EXCEPTION
import SpacingStyles from '../../../../styles/helpers/spacing';
import TypographyStyles from '../../../../styles/typography';
import combineStyles from '../../../../helpers/combineStyles';
import classnames from 'classnames';
import moment from 'moment-timezone';

import { PROMISSORY_STATUSES } from '../../../../constants/enums';

import _get from 'lodash/get';

const styles = theme => ({
  iconContainer: {
    position: 'absolute',
    left: 0,
    top: -8,
    width: '32px',
    height: '32px',
    backgroundColor: 'rgba(242,161,56,0.9)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconRoot: {
    color: ['#FFF', '!important'],
    fontSize: '18px'
  },
  activityDetail: {
    position: 'relative',
    display: 'inline-block',
    alignSelf: 'stretch'
  },
  activityName: {
    marginTop: [theme.spacing.unit * 1.5, '!important'],
    marginBottom: [theme.spacing.unit * 0.625, '!important']
  },

  itemContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingBottom: theme.spacing.unit * 5,
    paddingLeft: theme.spacing.unit * 6,
    position: 'relative'
  },
  verticalLine: {
    width: 1,
    height: '100%',
    borderRight: '1px dashed rgba(12,31,44,0.12);',
    position: 'absolute',
    left: 16
  }
});
export class Item extends PureComponent {
  static propTypes = {
    activity: PropTypes.object.isRequired
  };

  render() {
    const { classes, activity } = this.props;

    const ICONS = {
      [PROMISSORY_STATUSES.registered]: AssignmentIcon,
      [PROMISSORY_STATUSES.approved]: AssignmentTurnedInIcon,
      [PROMISSORY_STATUSES.rejected]: AssignmentLateIcon,
      [PROMISSORY_STATUSES.canceled]: NotInterestedIcon,
      [PROMISSORY_STATUSES.exeption]: WarningIcon
    };

    const label = PROMISSORY_STATUSES[activity.title];
    const Icon = ICONS[label] || WarningIcon;
    const comment =
      activity.comment && activity.comment != 'Éxito'
        ? '  - ' + activity.comment
        : '';

    return (
      <div className={classes.itemContainer}>
        <div className={classes.verticalLine} />
        <div className={classes.iconContainer}>
          <Icon color="primary" classes={{ root: classes.iconRoot }} />
        </div>
        <div className={classes.activityDetail}>
          <h4
            className={classnames(
              classes.noMargin,
              classes.caption,
              classes.boldWeight
            )}
          >
            {`${label}${comment}`}
          </h4>

          <h5 className={classnames(classes.subtitle3, classes.activityName)}>
            {moment(activity.date).format('YYYY-MM-DD [a las] h:mm A')}
          </h5>
          {activity.user && (
            <p className={classes.body2}>
              {`${_get(activity, 'user.firstName', '') || ''} ${_get(
                activity,
                'user.lastName',
                ''
              ) || ''}`}
            </p>
          )}
        </div>
      </div>
    );
  }
}
export default withStyles(
  combineStyles(styles, TypographyStyles, SpacingStyles)
)(Item);
